import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/site/Hero";
import Marquee from "../components/site/Marquee";
import ChiSiamo from "../components/site/ChiSiamo";
import Squadre from "../components/site/Squadre";
import Minibasket from "../components/site/Minibasket";
import ComeIscriversi from "../components/site/ComeIscriversi";
import Contatti from "../components/site/Contatti";
import { scrollToId } from "../lib/scroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const t = setTimeout(() => scrollToId(id), 350);
      return () => clearTimeout(t);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <Marquee />
      <ChiSiamo />
      <Squadre />
      <Minibasket />
      <ComeIscriversi />
      <Contatti />
    </>
  );
}
